/**
 * splashData.js
 * 
 * Array com os 15 personagens da tela de loading (splash).
 * 
 * Para alterar frases: edite apenas o campo `frase` de cada item.
 * Para alterar o personagem: edite `nome` e `file` (deve existir em public/assets/splash/).
 * Para adicionar mais splashes: adicione novos objetos ao array.
 * 
 * Imagens: public/assets/splash/splash_XX.webp (540×960px, formato WebP)
 * Em produção: /memoria-imortais/assets/splash/splash_XX.webp
 */

export const SPLASH_DATA = [
  {
    id: 1,
    file: 'splash_01.webp',
    nome: 'Abdias do Nascimento',
    frase: '"A resistência é a alma da liberdade."',
    cor: '#e8a000', // cor de destaque para o nome (opcional)
  },
  {
    id: 2,
    file: 'splash_02.webp',
    nome: 'Antonieta de Barros',
    frase: '"A educação é a maior herança que podemos deixar ao mundo."',
    cor: '#00e5ff',
  },
  {
    id: 3,
    file: 'splash_03.webp',
    nome: 'Bezerra da Silva',
    frase: '"O samba não mente — a favela tem alma."',
    cor: '#ff6b35',
  },
  {
    id: 4,
    file: 'splash_04.webp',
    nome: 'Carolina Maria de Jesus',
    frase: '"Escrever era a minha maneira de não afundar."',
    cor: '#d4af37',
  },
  {
    id: 5,
    file: 'splash_05.webp',
    nome: 'Cartola',
    frase: '"As rosas não falam, simplesmente as rosas exalam o perfume que elas têm."',
    cor: '#e8a000',
  },
  {
    id: 6,
    file: 'splash_06.webp',
    nome: 'Conceição Evaristo',
    frase: '"Escrevivência: viver para contar, contar para viver."',
    cor: '#9c27b0',
  },
  {
    id: 7,
    file: 'splash_07.webp',
    nome: 'Cruz e Sousa',
    frase: '"A arte é o grito do espírito que recusa o silêncio."',
    cor: '#00e5ff',
  },
  {
    id: 8,
    file: 'splash_08.webp',
    nome: 'Elza Soares',
    frase: '"A minha voz atravessa tudo o que tentaram silenciar."',
    cor: '#ff4081',
  },
  {
    id: 9,
    file: 'splash_09.webp',
    nome: 'Garrincha',
    frase: '"No campo, a alegria sempre venceu qualquer tristeza."',
    cor: '#4caf50',
  },
  {
    id: 10,
    file: 'splash_10.webp',
    nome: 'Grande Otelo',
    frase: '"O riso é uma das formas mais legítimas de dignidade."',
    cor: '#ff6b35',
  },
  {
    id: 11,
    file: 'splash_11.webp',
    nome: 'Lima Barreto',
    frase: '"Toda a glória que não é minha me é indiferente."',
    cor: '#d4af37',
  },
  {
    id: 12,
    file: 'splash_12.webp',
    nome: 'Machado de Assis',
    frase: '"A memória é a imaginação daqueles que já viveram."',
    cor: '#00e5ff',
  },
  {
    id: 13,
    file: 'splash_13.webp',
    nome: 'Marielle Franco',
    frase: '"Por todas elas, por todas nós."',
    cor: '#ff4081',
  },
  {
    id: 14,
    file: 'splash_14.webp',
    nome: 'Pixinguinha',
    frase: '"O choro é o abraço que a música dá na alma do povo."',
    cor: '#e8a000',
  },
  {
    id: 15,
    file: 'splash_15.webp',
    nome: 'Tim Maia',
    frase: '"Seja bem-vindo, amigo. O mundo é de você também."',
    cor: '#ffd700',
  },
];

/**
 * Retorna um splash aleatório, nunca repetindo o mesmo consecutivamente.
 * 
 * Usa sessionStorage para lembrar o último índice exibido.
 * O sessionStorage é limpo automaticamente quando o usuário fecha o browser/aba.
 * 
 * @returns {Object} Um objeto do SPLASH_DATA
 */
const SESSION_KEY = 'splash_last_index';

export function pickRandomSplash() {
  const total = SPLASH_DATA.length;
  const lastIndex = parseInt(sessionStorage.getItem(SESSION_KEY) ?? '-1', 10);

  let nextIndex;
  // Garante que não repete o mesmo personagem consecutivamente
  // Se total === 1, permite repetir (não entra em loop infinito)
  let attempts = 0;
  do {
    nextIndex = Math.floor(Math.random() * total);
    attempts++;
  } while (nextIndex === lastIndex && total > 1 && attempts < 10);

  sessionStorage.setItem(SESSION_KEY, String(nextIndex));
  return SPLASH_DATA[nextIndex];
}
